var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tagProcess.length)?_c('div',{ref:"chartdiv",staticClass:"convoreport"}):_c('div',{ref:"fakechart",staticClass:"convoreport report-overlay"})}
var staticRenderFns = []

export { render, staticRenderFns }